module.exports = __webpack_public_path__ + "files/7aee35e0d937a1fa3456645603d200e6.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-italic.woff
 ** module id = 978
 ** module chunks = 0
 **/